/* ==================================================================
   BREEZCORE — PRODUCT CARD BEHAVIOUR
   Design System v2.1 §17.3.

   One delegated listener for the whole document. A collection page
   renders 24+ cards; per-card binding is how a theme accumulates
   hundreds of listeners.

   Nothing here is required to see content. With JavaScript disabled
   the card renders complete and the pointer switch-on still works —
   this file exists only to give touch devices the same state.

   The toggle's accessible name never changes; aria-pressed carries
   the state. Rewriting the label as well is the common mistake and
   makes the control announce twice.

   Load with `defer`.
   ================================================================== */

(function () {
  'use strict';

  /* Initialisation guard. The listener is on `document`, so it
     survives Theme Editor section reloads without rebinding — but a
     section that also includes this asset would add a second
     listener and toggle the class twice per click. */
  if (window.bcCardReady) return;
  window.bcCardReady = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var toggle = target.closest('.bc-card__toggle');
    if (!toggle) return;

    var card = toggle.closest('.bc-card');
    if (!card) return;

    toggle.setAttribute(
      'aria-pressed',
      card.classList.toggle('is-lit') ? 'true' : 'false'
    );
  });
})();